/**
 * Configurações específicas para o cliente "Happy Consig"
 */
const settings: ClientSettings = {
  name: "Happy Consig",
  benefitCardName: "Amigoz",
  // supportEmail: "suporte@grupobyx.com.br",
  theme: {
    token: {
      colorPrimary: "#0097BA",
      colorHighlight: "#00BFDE",
    },
  },
  assets: {
    background: "/background.webp",
    logo: "/logo.png",
    favicon: "/favicon.png",
    card: "/card.png",
    consignedCard: "/consigned-card.png",
  },
  cardExclusiveTheme: {
    name: "Amigoz",
    theme: {
      token: {
        colorPrimary: "#00A2E0",
        colorHighlight: "#2DCCD2",
      },
    },
    assets: {
      background: "/background-card-exclusive.png",
      logo: "/logo-card-exclusive.png",
      favicon: "/favicon-card-exclusive.png",
    },
  },
};

export default settings;
